import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert as Alrt } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { updateAlert } from '../../../../services/api/alert';
import { ApiError, Alert } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import { Link, useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';

const AlertDetails = () => {
    const [alert, setAlert] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);

    const { keycloak } = useKeycloak();
    const token = keycloak.token || '';

   const navigate = useNavigate();
    
    const navigateBack = () => {
        navigate('/dashboard/lists/alerts');
    };


    const setAlertData = (data: Alert) => {
        localStorage.setItem('Alert', JSON.stringify(data));
    }

    useEffect(() => {
        if (alert == null) {
            const json = localStorage.getItem('Alert') ?? "";
            const item = JSON.parse(json);

            setAlert(item);
        }
    }, [alert]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        if (e.currentTarget.checkValidity()) {
            let alrt: Alert = alert;
            var update: Alert = {
                id: alrt.id,
                usernameConfirmation: keycloak.idTokenParsed?.preferred_username ?? '?'
            };
            setAlertData(alrt);
            updateAlert(token, alrt.id ?? 0, update).catch(err => console.log(err)).then((a : Alert) => {
                if (a !== undefined) {                    
                    setAlertData(a);
                    setAlert(a);
                }
                navigateBack();
            }).catch((error: ApiError) => {
                try {
                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                    {/* k0 contains field name: e.g. LocationSelection, k1 contains array of error messages*/ }
                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                } catch (ex) {
                    errorMsg.push("Error handling response");
                    setErrorMsg(errorMsg);
                    document.querySelector('#refresh')?.classList.add("d-none");
                }
            });
            setShowInputEle(!showInputEle);
        }
    }    

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">Alarmdetails</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {alert && Object.entries<PropertyInfo>(alert).filter(([key, value]) => !(key === "poi" && value === null) && !(key === "vmcIdentifier" && value === null) && alert["propertyNames"][key] !== undefined).sort((a, b) => alert["propertyNames"][a[0]].sortOrderLevel - alert["propertyNames"][b[0]].sortOrderLevel).map(([key, value], index) => (
                                                    <DetailItem key={index} propertyName={alert["propertyNames"][key].name} defaultValue={value ?? ""} rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"} editType={alert["propertyNames"][key].editType} pattern={alert["propertyNames"][key].valPattern} hideOnNull={alert["propertyNames"][key].hideOnNull}
                                                        handleDoubleClick={() => setShowInputEle(true)}
                                                        handleChange={(e: ChangeEvent<HTMLInputElement>) => { alert[key] = (e.target.value); setAlert(alert); }} showInputEle={showInputEle}></DetailItem>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg">
                                    <Col>
                                        {
                                            errorMsg.map((item, index) => {
                                                return <Alrt key={index} variant="warning" className="alert" role="alert">
                                                    <span>{item}</span>
                                                </Alrt>;
                                            })
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <Link to="/dashboard/lists/alerts" onClick={() => { }}>
                                            <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => { }}>Terug</button>
                                        </Link>
                                    </Col>
                                    <Col className="text-end">
                                        <button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }} disabled={ alert?.confirmationDateTime !== null }>Bevestig</button>
                                    </Col>
                                </Row>
                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default AlertDetails;